// Need to use the React-specific entry point to import createApi
import { baseApi } from "./baseApi";

// using CSRF token from Local Storage

// Define a service using a base URL and expected endpoints
export const transporterApi = baseApi.injectEndpoints({
  credentials: "include",
  endpoints: (builder) => ({
    addTransporter: builder.mutation({
      query: (data) => {
        return {
          url: "transporter",
          method: "POST",
          body: data,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
    updateTransporter: builder.mutation({
      query: ({ data, id }) => {
        return {
          url: `transporter/${id}`,
          method: "PATCH",
          body: data,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
    // deleteTransporter: builder.mutation({
    //   query: (id) => {
    //     return {
    //       url: `transporter/${id}`,
    //       method: "DELETE",
    //       // body: user,
    //       headers: {
    //         "Content-type": "application/json; charset=UTF-8",
    //       },
    //     };
    //   },
    //   // invalidatesTags: ['User'],
    // }),
    getTransporterDetail: builder.query({
      query: ({ id }) => {
        return {
          url: `transporter/${id}`,
          method: "GET",
        };
      },
    }),
    getAllTransporter: builder.query({
      query: (query) => {
        let queryString = new URLSearchParams(query).toString();
        return {
          url: `transporter?${queryString}`,
          method: "GET",
          // headers: {
          //   "Content-type": "application/json; charset=UTF-8",
          // },
        };
      },
      // keepUnusedDataFor: 300,
      refetchOnFocus: true,
      // providesTags: ['User'],
    }),
    getAllTrips: builder.query({
      query: (query) => {
        let queryString = new URLSearchParams(query).toString();
        return {
          url: `trip?${queryString}`,
          method: "GET",
          // headers: {
          //   "Content-type": "application/json; charset=UTF-8",
          // },
        };
      },
      // keepUnusedDataFor: 300,
      refetchOnFocus: true,
      // providesTags: ['User'],
    }),
    getTripDetail: builder.query({
      query: ({ id }) => {
        // let queryString = new URLSearchParams(query).toString();
        return {
          url: `trip/${id}`,
          method: "GET",
          // headers: {
          //   "Content-type": "application/json; charset=UTF-8",
          // },
        };
      },
      // keepUnusedDataFor: 300,
      refetchOnFocus: true,
      // providesTags: ['User'],
    }),
    getAllSchoolTransporter: builder.query({
      query: (query) => {
        let queryString = new URLSearchParams(query).toString();
        return {
          url: `school-transporter?${queryString}`,
          method: "GET",
          // headers: {
          //   "Content-type": "application/json; charset=UTF-8",
          // },
        };
      },
      // keepUnusedDataFor: 300,
      refetchOnFocus: true,
      // providesTags: ['User'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useAddTransporterMutation,
  useUpdateTransporterMutation,
  useGetAllTransporterQuery,
  useGetAllSchoolTransporterQuery,
  useGetTransporterDetailQuery,
  useGetAllTripsQuery,
  useGetTripDetailQuery,
  // useDeleteTransporterMutation,
} = transporterApi;
